export default __webpack_public_path__ + "3126f2caa76d3684770e4af9a449c7fb.png";